import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from "axios";
import {Status} from "./status";
import {headers} from "./headers";
import {Tag} from "./fields";
import {Location} from "./Shot";
import {Component} from "./setting";
import {host} from "./api";


export interface LocationsState {
    collection?: Array<Location>,
    lore?: Array<Location>,
    status: Status,
    error: string | null | undefined
}

const initialState: LocationsState = {
    collection: [],
    lore: [],
    status: Status.Idle,
    error: null,
}

export const fetchLocationsCollection = createAsyncThunk('fetchLocationsCollection', async (params: {projectId: number, storyId: number}) => {
    const response = await axios.get(`${host}/locations/collection/${params.storyId}`, {
        headers: headers(params.projectId?.toString())
    })
    return response.data
})

export const fetchLocationsLore = createAsyncThunk('fetchLocationsLore', async (params: {projectId: number, storyId: number}) => {
    const response = await axios.get(`${host}/locations/lore/${params.storyId}`, {
        headers: headers(params.projectId?.toString())
    })
    return response.data
})

export const saveLocation = createAsyncThunk('saveLocation', async (params: { projectId: number, location: Location }) => {
    const response = await axios.post(`${host}/locations`,
        params.location,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const deleteLocation = createAsyncThunk('deleteLocation', async (params: { projectId: number, locationId: number }) => {
    const response = await axios.delete(`${host}/locations/${params.locationId}`,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const removeLocationTag = createAsyncThunk('removeLocationTag', async (params: { projectId: number, locationId: number, tagId: number }) => {
    const response = await axios.delete(`${host}/locations/${params.locationId}/tags/${params.tagId}`,
        {
            headers: headers(params.projectId.toString())
        })
    return response.data
})

export const addLocationTag = createAsyncThunk('addLocationTag', async (params: { projectId: number, locationId: number, tag: Tag }) => {
    const response = await axios.post(`${host}/locations/${params.locationId}/tags`,
        params.tag,
        {
            headers: headers(params.projectId.toString())
        })
    return response.data
})


export const locationSlice = createSlice({
    name: 'locations',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(removeLocationTag.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(removeLocationTag.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(addLocationTag.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(addLocationTag.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(saveLocation.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(saveLocation.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(deleteLocation.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(deleteLocation.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(fetchLocationsCollection.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(fetchLocationsCollection.fulfilled, (state, action) => {
                state.status = Status.Succeeded
                state.collection = action.payload
            })
            .addCase(fetchLocationsLore.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(fetchLocationsLore.fulfilled, (state, action) => {
                state.status = Status.Succeeded
                state.lore = action.payload.map((location: Location) => {
                    const component = location as Component
                    return {
                        ...component,
                        layers: component.cover ? [{source: component.cover}] : [],
                        scale: 100,
                        component: component,
                        type: 'Location'
                    }
                })
            })
    }
})
export default locationSlice.reducer;